import React, { useEffect, useState } from "react";
import { request } from "../../../../utils/Request";
import { withTranslation } from "react-i18next";
import { dateToUtcDate, getColors, numberFormat, POINT_DECIMAL } from "../../../../utils/Helper";
import moment from "moment";
import ReactECharts from "echarts-for-react";

const KilometerPerTransportVehicle = (props: any) => {
    const { t, filters } = props;
    const [chartData, setChartData] = useState<any>();
    const [transportVehicleKilometers, setTransportVehicleKilometers] = useState<any>({
        grid: { top: 8, right: 8, bottom: 24, left: 36 },
        title: {
            // subtext: t('kilometer per truck'),
            // x: 'center'
        },
        tooltip: {
            trigger: 'axis',
        },
        xAxis: {
            type: 'category',
            data: [],
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: [],
                type: 'bar',
                smooth: true,
            },
        ],
    });

    const getTransportVehicleKilometer = async () => {
        try {
            const response = await request({
                url: '/suppliers/dashboards/management/kilometer/per/transport/vehicles',
                params: {
                    from: (
                        filters.from
                            ? moment(filters.from).clone().tz(moment.tz.guess()).utc().format("YYYY-MM-DD 00:00:00")
                            : moment().startOf("year").startOf("day").tz(moment.tz.guess()).utc().format("YYYY-MM-DD 00:00:00")
                    ),
                    to: (
                        filters.to
                            ? moment(filters.to).clone().tz(moment.tz.guess()).utc().format("YYYY-MM-DD 23:59:59")
                            : moment().endOf("year").endOf("day").tz(moment.tz.guess()).utc().format("YYYY-MM-DD 23:59:59")
                    )
                }
            });

            const { data } = response.data;
            setChartData(data);

            const colors = getColors();

            setTransportVehicleKilometers({
                ...transportVehicleKilometers,
                xAxis: {
                    type: "category",
                    data: data.collection.map((item: any) => item.month_name),
                    axisLabel: {
                        width: 30, //fixed number of pixels
                        overflow: 'truncate', // or 'break' to continue in a new line
                        interval: 0,
                        // interval: 0,
                        rotate: 30 //If the label names are too long you can manage this by rotating the label.
                    }
                },
                dataZoom: [
                    {
                        type: 'inside'
                    }
                ],
                grid: { containLabel: true },
                yAxis: {
                    type: "value",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                    formatter: (params: any) => {
                        return ` <strong>${ params[0].name }</strong> <br />
                            ${ params[0].seriesName }: ${ numberFormat(params[0].value, POINT_DECIMAL, ',', '.') }
                        `;
                    },
                },
                series: [
                    {
                        data: data.collection.map((item: any) => item.total),
                        name: t('total'),
                        stack: "one",
                        type: "bar",
                        itemStyle: {
                            color: (params: any) => colors[params.dataIndex]
                        }
                    },
                ],
            });
        } catch (e) {
            console.log(e)
        }
    };

    const onClickOnBarChart = (params: any) => {
        if ( !params.data ) {
            return;
        }

        const subData = chartData.collection.find((data: any) => {
            return data.month_name === params.name;
        });

        if ( !subData ) {
            return;
        }

        const colors = getColors();

        setTransportVehicleKilometers({
            xAxis: {
                data: subData.group.map((item: any) => item.name),
                axisLabel: {
                    // inside: true,
                    width: 30, //fixed number of pixels
                    overflow: 'truncate', // or 'break' to continue in a new line
                    interval: 0,
                    rotate: 30 //If the label names are too long you can manage this by rotating the label.
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
            },
            dataGroupId: '',
            grid: { containLabel: true },
            yAxis: {
                type: "value",
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {
                    type: "shadow",
                },
                formatter: (params: any) => {
                    return ` <strong>${ params[0].axisValue }</strong> <br />
                        ${ numberFormat(params[0].data, POINT_DECIMAL, ',', '.') }
                    `;
                },
            },
            series: {
                type: 'line',
                smooth: true,
                dataGroupId: subData.client,
                data: subData.group.map((item: any) => item.total),
                universalTransition: {
                    enabled: true,
                    divideShape: 'clone'
                },
                // itemStyle: {
                //     color: (params: any) => colors[params.dataIndex]
                // }
            },
            graphic: [
                {
                    type: 'text',
                    left: 50,
                    top: 20,
                    style: {
                        text: 'Back',
                        fontSize: 18
                    },
                    onclick: () => setTransportVehicleKilometers(transportVehicleKilometers)
                }
            ]
        });
    };

    const onEvents = {
        click: onClickOnBarChart
    };

    useEffect(() => {
        async function init() {
            await getTransportVehicleKilometer();
        }

        init();
    }, [filters]);

    return (
        <div>
            <ReactECharts
                option={ transportVehicleKilometers }
                onEvents={ onEvents }
                style={ { height: '500px' } }
            />
        </div>
    );
};

export default withTranslation()(KilometerPerTransportVehicle);
